import fastApiClient from "../lib/fastAPI"
import axios from "axios"

// セクションデータを取得する関数
export const fetchSectionData = async (size: string) => {
  try {
    const response = await fastApiClient.post("steel/post_section/", {
      size,
    })
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(
        `Error: ${error.response.status} - ${error.response.data.detail}`,
      )
    } else {
      throw new Error("An unexpected error occurred")
    }
  }
}

// セクションデータを取得する関数
export const fetchSectionFreeData = async () => {
  try {
    const response = await fastApiClient.get(
      "free/get_section/excel/h/A?H=300&B=150&tw=6.5&tf=9",
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(
        `Error: ${error.response.status} - ${error.response.data.detail}`,
      )
    } else {
      throw new Error("An unexpected error occurred")
    }
  }
}

export const downloadExcelTemplate = async (
  templateName: string,
  inputData: object,
) => {
  try {
    const response = await fastApiClient.post(
      `excel/edit/${templateName}`,
      inputData,
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(
        `Error: ${error.response.status} - ${error.response.data.detail}`,
      )
    } else {
      throw new Error("An unexpected error occurred")
    }
  }
}

export const downloadZumenTemplate = async (
  templateName: string,
  fileType: "dxf" | "jww",
) => {
  try {
    // APIエンドポイントを動的に設定
    const response = await fastApiClient.post(
      `zumen/${fileType}/${templateName}`,
    )
    const downloadLink = response.data.download_link

    // ダウンロードリンクからファイルを取得
    const fileResponse = await axios.get(downloadLink, {
      responseType: "blob",
    })

    // ファイルをダウンロード
    const url = window.URL.createObjectURL(new Blob([fileResponse.data]))
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", `${templateName}.${fileType}`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(
        `Error: ${error.response.status} - ${error.response.data.detail}`,
      )
    } else {
      throw new Error("An unexpected error occurred")
    }
  }
}
